class User {
  public accessToken: any
  public idToken: any
  public expiresAt: any
  public userProfile: any

  public IsAuthenticated () {
    return this.accessToken && this.idToken && this.expiresAt && new Date().getTime() < this.expiresAt
  }

  public ToJSON () {
    return JSON.stringify(this)
  }
}

export default User
